// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 身份证 OCR 识别（上传照片） POST /api/v1/ocr/id-card */
export async function OcrControllerRecognizeIdCardV1(
  body: MyApi.CreateOcrDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputOcrIdCardDto>("/api/v1/ocr/id-card", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
